module.exports = "https://cdn.realtymogul.com/static/media/HP_card_walnut_place.03f9a6a3.jpg";